import { useEffect, useState } from 'react';

/** True below Tailwind's `sm` (640 px): for text that cannot be shortened with
 *  CSS alone, such as an input's placeholder. False where matchMedia is absent. */
export function useNarrow(): boolean {
  const query = '(max-width: 639px)';
  const [narrow, setNarrow] = useState(() => (typeof window !== 'undefined' && window.matchMedia?.(query)?.matches) || false);
  useEffect(() => {
    const m = window.matchMedia?.(query);
    if (!m) return undefined;
    const on = () => setNarrow(m.matches);
    on();
    m.addEventListener?.('change', on);
    return () => m.removeEventListener?.('change', on);
  }, []);
  return narrow;
}
